import { createSlice } from "@reduxjs/toolkit"
import {
	handlePostOrderSliceBuilder,
	handleProductLabelOrderSliceBuilder,
} from "./bikeLabelOrderBuilders"
import { BikeLabelOrderState } from "../types"
import * as reducerActions from "./bikeLabelOrderAction"
import {
	confirmationInitState,
	orderInitState,
	shippingInitState,
} from "./bikeLabelOrderInitialState"

export const initialStateOrderStep: BikeLabelOrderState = {
	...orderInitState,
	...shippingInitState,
	...confirmationInitState,
}

export const bikeLabelOrderSlice = createSlice({
	name: "bikeLabelOrder",
	initialState: initialStateOrderStep,
	reducers: {
		setProductQuantity: reducerActions.setProductQuantity,
		updateOrderBillingInformation: reducerActions.updateOrderBillingInformation,
		handleChangeOrderBilingInformation: reducerActions.handleChangeOrderBilingInformation,
		handleValidationOrderBilingInformation:
			reducerActions.handleValidationOrderBilingInformation,
		handleToggleShowLocalBilingError: reducerActions.handleToggleShowLocalBilingError,
		handleMemorizeLastStepValidate: reducerActions.handleMemorizeLastStepValidate,
		handleClearOrderState: reducerActions.handleClearOrderState,
		handleFinishOrder: reducerActions.handleFinishOrder,
	},
	extraReducers(builder) {
		handleProductLabelOrderSliceBuilder(builder)
		handlePostOrderSliceBuilder(builder)
	},
})

export const {
	setProductQuantity,
	updateOrderBillingInformation,
	handleChangeOrderBilingInformation,
	handleValidationOrderBilingInformation,
	handleToggleShowLocalBilingError,
	handleMemorizeLastStepValidate,
	handleClearOrderState,
	handleFinishOrder,
} = bikeLabelOrderSlice.actions
